import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = {get_theme_report_loading : true, get_theme_report: '', get_theme_report_error: false};

export function getReportTheme(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_GET_THEME_REPORT:
        return {
            get_theme_report_loading: true,
            get_theme_report: '',
            get_theme_report_error: false
        };
      case organisationConstants.RESPONSE_GET_THEME_REPORT:
        return {
            get_theme_report_loading: false,
            get_theme_report: action.get_theme_report,
            get_theme_report_error: false
        };
      case organisationConstants.ERROR_GET_THEME_REPORT:
        return { 
            get_theme_report_loading: false,
            get_theme_report: '',
            get_theme_report_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/getThemeReport.reducer.js